const DAY_OR_NIGHT = {
  DAY: 'Day',
  NIGHT: 'Night',
  DAY_AND_NIGHT: 'Day and Night',
};

export default DAY_OR_NIGHT;
